import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import circle_download from "../../assets/img/circle_download.svg";
import export_img from "../../assets/img/export.svg";
import Header from "../Header/Header";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "../../redux/GetProfileSlice";
import { getAllPayments, getAllSubscriptions } from "../../redux/getProfileActivitySlice";
import { format } from 'date-fns';

const ProfileHeader = () => {
  const [profileData, setProfileData] = useState({});
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const [subscriptions, setSubscriptions] = useState(null);
  const [payments, setPayments] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const profileResponse = useSelector((state) => state.getProfileReducer.data);
  const allSubscriptionsResponse = useSelector((state) => state.profileActivity.allSubscription);
  const allPaymentsResponse = useSelector((state) => state.profileActivity.allPayments);

  useEffect(() => {
    dispatch(getProfile());
    dispatch(getAllPayments());
    dispatch(getAllSubscriptions());
  }, [dispatch]);

  useEffect(() => {
    if (profileResponse != null && profileResponse.status === 1) {
      setProfileData(profileResponse.data);
    }
  }, [profileResponse]);

  useEffect(() => {
    if (allSubscriptionsResponse != null && allSubscriptionsResponse.status === 1) {
      setSubscriptions(allSubscriptionsResponse.data);
    }
  }, [allSubscriptionsResponse]);

  useEffect(() => {
    if (allPaymentsResponse != null && allPaymentsResponse.status === 1) {
      setPayments(allPaymentsResponse.data);
    }
  }, [allPaymentsResponse]);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <div className="sidebar_mar">
      <Header />

      <div className="profile_btn_styles">
        <h2>Profile</h2>
        <Button type="button" onClick={() => navigation("/EditProfile")}>
          Edit Profile
        </Button>
      </div>

      {profileData && <div className="profile_content">

        <div className="profile_ditz">
          <div className="profile-left">
            <h3>Profile Info</h3>
            <img src={circle_download} alt="Download" height={120} style={{ marginBottom: "1rem" }} />
            <div className="name_email_Number">
              <p>Name:</p>
              <h4>
                {profileData?.firstName?.length > 2
                  ? profileData?.firstName
                  : "Not Available"}{" "}
                {profileData?.lastName?.length > 2
                  ? profileData?.lastName
                  : ""}
              </h4>
            </div>

            <div className="name_email_Number">
              <p>Email Address:</p>
              <h4>
                {profileData?.email?.length > 2
                  ? profileData?.email
                  : "Not Available"}
              </h4>
            </div>

            {profileData?.role === 'User' && <div className="name_email_Number">
              <p>Company Name:</p>
              <h4>
                {profileData?.companyName?.length > 2
                  ? profileData?.companyName
                  : "Not Available"}
              </h4>
            </div>}

            {profileData?.role === 'User' && <div className="name_email_Number">
              <p>Users:</p>
              <h4>
                {profileData?.noOfEmployeeCreated}
              </h4>
            </div>}

            {profileData?.role === 'User' && profileData.userSubscription && <div className="name_email_Number">
              <p>Users Limit:</p>
              <h4>
                {profileData?.userSubscription?.usersIncluded || 0}
              </h4>
            </div>}

            {profileData?.role === 'User' && <div className="name_email_Number">
              <p>Subscribed:</p>
              <h4>
                {profileData?.isSubscribed === 1 ? 'Yes' : 'No'}
              </h4>
            </div>}
          </div>

          {profileData?.userSubscription && profileData?.userSubscription?.subscriptionPlan && <div className="profile-right">
            <h3>Subscriptions</h3>
            <div className="plan-card-profile">
              <div className="plan-card-header">

                <div className="gradient-border">
                  <h3>{profileData?.userSubscription?.subscriptionPlan?.name}</h3>
                </div>

              </div>

              <div className="plan-card-body">

                <p className="users-profile">
                  Includes {profileData?.userSubscription?.usersIncluded} users
                </p>

                <div className="price">
                  ${profileData?.userSubscription?.subscriptionPlan?.basePrice}
                  <span className="pipe"></span>
                  {profileData?.userSubscription?.subscriptionPlan?.durationType !== "one-time" ? (
                    <span className="duration">
                      {profileData?.userSubscription?.subscriptionPlan?.duration} {profileData?.userSubscription?.subscriptionPlan?.durationType}
                      {profileData?.userSubscription?.subscriptionPlan?.duration > 1 ? "s" : ""}
                    </span>
                  ) : (
                    <span className="duration">one time</span>
                  )}
                </div>

                <p className="users-profile" style={{ marginBottom: "5px", marginTop: "5px" }}>
                  Start Date
                </p>

                <p className="sub-date">
                  {format(new Date(profileData?.userSubscription?.startDate), 'dd MMM yyyy')}
                </p>

                <p className="users-profile" style={{ marginBottom: "5px", marginTop: "5px" }}>
                  End Date
                </p>

                <p className="sub-date">
                  {format(new Date(profileData?.userSubscription?.endDate), 'dd MMM yyyy')}
                </p>
              </div>


              <div className="plan-card-footer">
                {profileData && (
                  <button
                    className="continue-btn"
                    onClick={() => { setShowModal(true) }}
                    disabled={!profileData?.userSubscription?.subscriptionPayment}
                    type="button"
                  >
                    Payment Info
                  </button>
                )}
              </div>
            </div>
          </div>}



        </div>
      </div>}

      {/* {subscriptions && subscriptions.length !== 0 && profileData?.role === 'User' && (
        <div className="table-container">
          <h2 className="table-heading">Subscriptions</h2>
          <table className="data-table">
            <thead>
              <tr>
                <th>Plan</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Amount</th>
                <th>Transaction ID</th>
                <th>Emp Limit</th>
                <th>Payment Mode</th>
                <th>Active</th>
              </tr>
            </thead>
            <tbody>
              {subscriptions.map((row, index) => (
                <tr key={index} className={row.isActive ? "highlight" : ""}>
                  <td>{row.subscriptionPlan?.name}</td>
                  <td>{format(new Date(row.startDate), 'dd MMM yyyy')}</td>
                  <td>{format(new Date(row.endDate), 'dd MMM yyyy')}</td>
                  <td>${row.payment?.amount}</td>
                  <td>{row.payment?.transactionId}</td>
                  <td>{row?.subscriptionPlan?.usersIncluded || 0}</td>
                  <td>{row.payment?.paymentMode}</td>
                  <td>{row.isActive ? 'Yes' : 'No'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}


      {payments && payments.length !== 0 && profileData?.role === 'User' && (
        <div className="table-container">
          <h2 className="table-heading">Payments</h2>
          <table className="data-table">
            <thead>
              <tr>
                <th>Transaction ID</th>
                <th>Amount</th>
                <th>Payment Mode</th>
                <th>Payment Type</th>
                <th>Status</th>
                <th>Paid At</th>
                <th>Info</th>
              </tr>
            </thead>
            <tbody>
              {payments.map((row, index) => (
                <tr key={index}>
                  <td>{row.transactionId}</td>
                  <td>${row.amount}</td>
                  <td>{row.paymentMode}</td>
                  <td>{row.paymentType}</td>
                  <td>{row.paymentStatus}</td>
                  <td>{format(new Date(row.paidAt), 'dd MMM yyyy')}</td>
                  <td>
                    <a href={row.hostedInvoiceUrl} target="_blank" rel="noopener noreferrer">
                      View
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )} */}

      {showModal && profileData?.userSubscription && profileData?.userSubscription.subscriptionPayment && profileData?.userSubscription?.subscriptionPlan && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "#35364133",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000,
        }}>
          <div style={{
            background: "#fff",
            borderRadius: "24px",
            padding: "40px",
            width: "90%",
            maxWidth: "550px",
            boxShadow: "0px 0px 20px #00000017",
            overflow: "hidden",
          }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                paddingBottom: "15px",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <h3 style={{
                marginBottom: "1rem",
                fontSize: "28px",
                color: "#0F0F0F",
                fontWeight: "700",
              }}>
                Payment info
              </h3>
              <div className="payment-info">
                <div className="info-payment-key-value">
                  <p>Plan:</p>
                  <h4>
                    {profileData?.userSubscription?.subscriptionPlan?.name}
                  </h4>
                </div>

                <div className="info-payment-key-value">
                  <p>Transaction ID:</p>
                  <h4>
                    {profileData?.userSubscription.subscriptionPayment?.transactionId}
                  </h4>
                </div>

                <div className="info-payment-key-value">
                  <p>Payment Mode:</p>
                  <h4>
                    {profileData?.userSubscription.subscriptionPayment?.paymentMode}
                  </h4>
                </div>

                <div className="info-payment-key-value">
                  <p>Amount:</p>
                  <h4>
                    ${profileData?.userSubscription.subscriptionPayment?.amount}
                  </h4>
                </div>


                <div className="info-payment-key-value">
                  <p>Payment Type:</p>
                  <h4>
                    {profileData?.userSubscription.subscriptionPayment?.paymentType}
                  </h4>
                </div>

                <div className="info-payment-key-value">
                  <p>Status:</p>
                  <h4>
                    {profileData?.userSubscription.subscriptionPayment?.paymentStatus}
                  </h4>
                </div>

                <div className="info-payment-key-value">
                  <p>Paid At:</p>
                  <h4>
                    {format(new Date(profileData?.userSubscription.subscriptionPayment?.paidAt), 'dd MMM yyyy')}
                  </h4>
                </div>

                <div className="info-payment-key-value">
                  <p>Invoice:</p>
                  <h4>
                    <a href={profileData?.userSubscription.subscriptionPayment?.hostedInvoiceUrl} target="_blank" rel="noopener noreferrer">
                      View Invoice <img src={export_img} alt="export" width={12} />
                    </a>
                  </h4>
                </div>
              </div>

              <Button
                style={{
                  fontFamily: "inherit",
                  padding: "12px 24px",
                  fontSize: "15px",
                  fontWeight: 700,
                  cursor: "pointer",
                  color: "#FFFFFF",
                  backgroundColor: "#0F0F0F",
                  borderRadius: "8px",
                  width: "100%"
                }}
                onClick={handleCloseModal}
              >OK</Button>
            </div>

          </div>
        </div>
      )}

    </div>
  );
};

export default ProfileHeader;
